import React from 'react';
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';
import CustomHandle from './CustomHandle';
import { Position } from 'reactflow';

const handleStyle: React.CSSProperties = {
    backgroundColor: '#7D52FF',
    height: 15,
    width: 15,
    borderRadius: '100%',
    top: '60%',
};

interface CodeNodeData {
    variableName?: string;
    codeSnippet?: string;
}

interface CodeNodeProps {
    data: CodeNodeData;
    isConnectable: boolean;
}

const CodeNode: React.FC<CodeNodeProps> = ({ data, isConnectable }) => {
    return (
        <div
            className="d-flex flex-column justify-content-between align-items-center"
            style={{
                border: `1px solid ${colors.borderwhite}`,
                borderRadius: 16,
                backgroundColor: colors.white01,
                width: 250,
            }}
        >
            {/* Left Handle */}
            <CustomHandle
                type="target"
                position={Position.Left}
                isConnectable={isConnectable}
                style={handleStyle}
            />

            {/* Header */}
            <div
                className="d-flex flex-row justify-content-between align-items-center w-100"
                style={{
                    paddingInline: 16,
                    paddingBlock: 8,
                    backgroundColor: '#7D52FF',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                }}
            >
                <p style={{ fontWeight: 700, color: colors.white }}>{'Custom Code'}</p>
                <img
                    src={images.Edit}
                    style={{
                        height: 20,
                        width: 20,
                        objectFit: 'contain',
                        cursor: 'pointer',
                    }}
                />
            </div>

            {/* Body */}
            <div
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{ paddingInline: 16, paddingBlock: 16 }}
            >
                {/* Variable Name */}
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: colors.black,
                        width: '100%',
                        textAlign: 'center',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        wordBreak: 'break-all',
                    }}
                >
                    {data?.variableName ? data.variableName : 'Set variable name'}
                </p>

                {/* Optional: Show snippet preview */}
                {data?.codeSnippet && (
                    <p
                        style={{
                            fontSize: 12,
                            fontWeight: 300,
                            color: colors.grey,
                            width: '100%',
                            textAlign: 'center',
                            marginTop: 4,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                        }}
                    >
                        {data.codeSnippet}
                    </p>
                )}
            </div>

            {/* Right Handle */}
            <CustomHandle
                type="source"
                position={Position.Right}
                style={handleStyle}
                isConnectable={1}
            />
        </div>
    );
};

export default CodeNode;
